import React from "react";
// import FirebaseOperation from '../pages/FirebaseOperation';
import './events.css';
// import CSImage from '../Images/casting_call.jpg';

const events = ()=>{

                           
    return (
        // <div id="castcontainer">



        <div style={{fontSize: '25px', textShadow: '1px 2px 9px blue', textAlign: 'center'}}>
        No new notification!
        </div>






        // </div>
    );
}

export default events;